// Module
var code = "<p>Lead all Wordpress development initiatives for previously WeWork owned Conductor.com – conduct A/B testing on homepage and develop changes which resulted in a 20% increase in conversion rate. </p>";
// Exports
export default code;